<template>
  
    <bk-page v-if="!tempShopInfo" :loading="true" class="oblissIndexPage">
  
    </bk-page>
  
    <SwitchStore v-else :shop-info="tempShopInfo" hideBackFlag @action="shopAction">
  
    </SwitchStore>
  
  
  </template>
  
  <script>
  
	import SwitchStore from '../reserve/subViews/storeInfo/switchStore/switchStore.vue';
  
	import { authReq } from '@/reqService';
	import {shopReq} from '../../reqService';
  
	export default {
		name: 'oblissIndex',
		components: {
			SwitchStore
		},
		computed: {},
		data () {
			return {
				showPage: 'KisHome',
				anchors: '',
				showResFlag: false,
				openMenu: false,
  
				tempShopInfo: undefined,
			};
		},
		async created () {
			// document.title = 'KIS Hair - Melbourne | Haircuts and Hairdressing';
      
			let reloadPath = '/';
  
			if (window.reloadPath) {
				reloadPath = window.reloadPath;
				delete window.reloadPath;
			}
        
			if (this.$bk_getAccessToken() && this.$bk_getAccessToken() != '') {
				let userInfo = await authReq.requestGetUserInfoByToken(this, {}).catch(() => {});
  
				if (!userInfo) {
					this.$bk_setAccessToken(undefined);
				}
				bkLog.log('Index_userInfo:', userInfo);
  
				if (userInfo) {
					userInfo.id = userInfo.id || userInfo.userId;
  
					if (userInfo.language && userInfo.language.languageCode) {
						this.$bk_switchLang(userInfo.language.languageCode);
					}
					this.$bk_setUserInfo(userInfo);
				} else {
					this.$bk_setAccessToken(undefined);
				}
			}
  
			this.requestInitData();
  
			// this.$router.replace(reloadPath);
		},
		methods: {
  
  
			shopAction (e) {
  
				bkLog.log('shopAction:::', e);
  
				if (e?.key == 'switchStore') {
  
					let {item} = e;
  
					localStorage.setItem('obliss-cacheShopInfo', JSON.stringify({
						id: item.id,
						custId: item.custId,
						compCode: item.compCode,
						name: item.compName || item.name,
						compName: item.compName || item.name,
					}));
  
  
					this.$router.replace(`/shopDetail?custId=${item.custId}&compId=` + item.id);
				}
  
			},
  
			async requestInitData () {
				let cacheShopInfo = localStorage.getItem('obliss-cacheShopInfo');
      
				if (!cacheShopInfo) {
  
					let chainInfo = await shopReq.requestGetChainInfoByKeyword(this, {custId: 'OBLISSBEAUTYSALON'}).catch(() => {});
  
					chainInfo.canReserveCompanyList = chainInfo.companyList.filter((item) => {
						// 对外可预约 没过期
						return item.canReserve===1 && !item.compExpired;
					});
  
					bkLog.log('返回的缓存连锁信息ABC:', chainInfo);
  
					console.log('chainInfo.canReserveCompanyList:::', chainInfo.canReserveCompanyList);
  
					// cacheShopInfo = chainInfo.canReserveCompanyList[0];
  
  
					this.tempShopInfo = chainInfo;
					return;
  
            
				} else {
					cacheShopInfo = JSON.parse(cacheShopInfo);
				}
  
				bkLog.error('cacheShopInfo:::', cacheShopInfo);
          
				this.$router.replace(`/shopDetail?custId=${cacheShopInfo.custId}&compId=` + cacheShopInfo.id);
			},
		}
	};
  </script>
  
  <style lang="less">
  
  
  .KISLoadPage {
    height: 100vh !important;
    .configImgUrlBc('Def_KIS_C_LoginBC.png', @color-bc-def, center top / 100% 100% no-repeat) !important;
  }
  
  .KISIndexPage {
    height: 100vh !important;
    background: #fff;
  
    @font-face {
      font-family: futura-lt-w01-light;
      src: url('https://static-global.boka.vc/mase/customer/futura-lt-w01-light.woff2') format('woff2');
    }
    @font-face {
      font-family: didot-w01-italic;
      src: url('https://static-global.boka.vc/mase/customer/didot-w01-italic.woff2') format('woff2');
    }
  
    .view-pageBox {
      height: 100%;
      --site-width: 320px;
  
  
      > .view-header {
        padding: calc(12px + env(safe-area-inset-top)) 16px 12px 16px;
        min-height: calc(64px + env(safe-area-inset-top));
        display: flex;
        justify-content: space-between;
  
        > .view-nav {
          img + img {
            margin-left: 12px;
          }
        }
      }
  
      > .view-iframe {
        width: 100%;
        //height: calc(100% - env(safe-area-inset-top) - 64px);
        min-height: calc(100% - env(safe-area-inset-top) - 64px);
      }
    }
  
    .view-menu {
      width: 100%;
      display: flex;
      flex-direction: column;
      padding: 120px 12px;
      position: relative;
  
      .toggle{
        position: absolute;
        top: calc(env(safe-area-inset-top) + 20px);
        right: 12px;
      }
  
      .bk-button {
        font-size: 20px;
        color: #000000;
  
        & + .bk-button {
          margin-top: 20px;
        }
  
      }
    }
  }
  
  </style>
  
  <style scoped>
  .toggle-btn {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 30px;
    height: 20px;
    cursor: pointer;
    position: relative;
  }
  
  .toggle-btn-line {
    width: 100%;
    height: 2px;
    border-radius: 2px;
    background-color: #000;
    transition: transform 0.3s ease, opacity 0.3s ease;
  }
  
  .toggle-btn-line:nth-child(1) {
    transform: translateY(0);
  }
  
  .toggle-btn-line:nth-child(2) {
    transform: translateY(0);
  }
  
  .toggle-btn-line:nth-child(3) {
    transform: translateY(0);
  }
  
  .toggle-btn.active .toggle-btn-line:nth-child(1) {
    transform: translateY(9px) rotate(-45deg);
  }
  
  .toggle-btn.active .toggle-btn-line:nth-child(2) {
    opacity: 0;
  }
  
  .toggle-btn.active .toggle-btn-line:nth-child(3) {
    transform: translateY(-9px) rotate(45deg);
  }
  </style>
  